import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as MdIcons from 'react-icons/md'
import '../../assets/css/stylesheets/components/card/VerticalEntryCard.css'

function VerticalStaffCard({ staffMember }) {

    const imageSrc = `data:image/jpeg;base64,${staffMember.Picture}`;

    return (
        <div className='verticalentrycard slide-in-right'>
            <div className='verticalentrycard-media'>
                <img className='verticalentrycard-media-image' src={imageSrc} />
            </div>
            <div className='verticalentrycard-content'>
                <div className='verticalentrycard-content-title'>
                    {staffMember.FirstName} {staffMember.LastName}
                </div>
                <div className='verticalentrycard-content-description'>
                    {staffMember.PositionTitle}
                </div>
                <div>

                    {
                        staffMember.WorkPhone ? (
                            <div>
                                <MdIcons.MdWork className='verticalentrycard-content-contact-icon' />
                                {staffMember.WorkPhone}
                            </div>) : (
                            <></>
                        )
                    }
                    {
                        staffMember.CellPhone ? (
                            <div>
                                <FaIcons.FaMobileAlt className='verticalentrycard-content-contact-icon' />
                                {staffMember.CellPhone}
                            </div>) : (
                            <></>
                        )
                    }
                    {
                        staffMember.Email ? (
                            <div>
                                <MdIcons.MdMail className='verticalentrycard-content-contact-icon' />
                                <a href={`mailto:${staffMember.Email}`}>{staffMember.Email}</a>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    {
                        staffMember.Fax ? (
                            <div>
                                <FaIcons.FaFax className='verticalentrycard-content-contact-icon' />
                                {staffMember.Fax}
                            </div>) : (
                            <></>
                        )
                    }
                </div>
                <div className='verticalentrycard-seperator'></div>
                <div className='verticalentrycard-quick-actions'>
                    {
                        staffMember.LinkedInURL ? (
                            <a href={staffMember.LinkedInURL} target='blank' rel='noopener'>
                                <FaIcons.FaLinkedinIn />
                            </a>) : (
                            <></>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default VerticalStaffCard